import styled from 'styled-components'

export const Container = styled.div`
  background: #2d2d2d;
  box-shadow: inset 12px 0 15px -12px hsl(0deg 0% 0% / 40%);
  box-sizing: border-box;
  padding: 10px 0;
`

export const Block = styled.div`
  padding: 10px 15px;
`

export const Title = styled.div`
  margin-bottom: 5px;
`

export const Section = styled.div`
  margin-bottom: 5px;
`

export const FileInput = styled.input`
  visibility: hidden;
  position: absolute;
  z-index: -1;
`
